export default function({ $auth, $sentry }) {
  if (!$auth.user) return

  $sentry.setUser($auth.user)
  $sentry.setTag('user_email', $auth.user.email)
  $sentry.setTag('user_name', $auth.user.firstName + ' ' + $auth.user.lastName)
}
